


<div *ngIf="drillDownDataStatus" class="card dashboardTable">
    <p-toolbar styleClass="mb-4">
        <ng-template pTemplate="left">
            <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                class="p-button-success"></button> -->
            <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
        </ng-template>
        <ng-template pTemplate="right" class="parent_dialog" >
            <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
            <button (click)="menu_dialog.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload" 
                class="p-button-help"></button>
           
            <p-menu styleClass="prime-slider-override" class="child_dialog"  #menu_dialog [popup]="true" [model]="appVerificationItems_dialog"></p-menu>
        </ng-template>

    </p-toolbar>
    <p-table #miSurvey [value]="drillDownData" [scrollable]="true" scrollHeight="flex" scrollHeight="400px" dataKey="AppId_ProgID"
    [rows]="10"
    [paginator]="true"
    [globalFilterFields]="[
    'AppId',
    'ApprovedDate',
    'FarmerName',
    'Father_name', 
    'Mother_Name',
    'Mobile',
    'District',
    'Constituency',
    'Block',
    'Village',
    'Total_Area',
    
    
    ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id" 
    currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
    [showCurrentPageReport]="true" [loading]="loading">
    <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text"
                    (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                    placeholder="{{'SEARCH'| translate}}" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">

        <tr>
          
            
            <th pSortableColumn="AppId">{{'APP_ID'| translate}}
                <p-columnFilter type="text" field="AppId" display="menu"></p-columnFilter>
                <p-sortIcon field="AppId"></p-sortIcon>
            </th>
            <th *ngIf="isDate" pSortableColumn="ApprovedDate">{{'APPROVED_DATE'| translate}}
                <p-columnFilter type="text" field="ApprovedDate_filter" display="menu"></p-columnFilter>
                <p-sortIcon field="ApprovedDate"></p-sortIcon>
            </th>
            <th pSortableColumn="FarmerName">{{'FARMER_NAME'| translate}}
                <p-columnFilter type="text" field="FarmerName" display="menu"></p-columnFilter>
                <p-sortIcon field="FarmerName"></p-sortIcon>
            </th>
            <th pSortableColumn="Father_name">{{'FATHER_NAME'| translate}}
                <p-columnFilter type="text" field="Father_name" display="menu"></p-columnFilter>
                <p-sortIcon field="Father_name"></p-sortIcon>
            </th>
            <th pSortableColumn="Mother_Name">{{'MOTHER_NAME'| translate}}
                <p-columnFilter type="text" field="Mother_Name" display="menu"></p-columnFilter>
                <p-sortIcon field="Mother_Name"></p-sortIcon>
            </th>
            
            <th pSortableColumn="Mobile">{{'MOBILE'| translate}}
                <p-columnFilter type="text" field="Mobile" display="menu"></p-columnFilter>
                <p-sortIcon field="Mobile"></p-sortIcon>
            </th>
            
            
            <th pSortableColumn="District">{{'DISTRICT'| translate}}
                <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                <p-sortIcon field="District"></p-sortIcon>
            </th>
            <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
                <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
                <p-sortIcon field="Constituency"></p-sortIcon>
            </th>
            <th pSortableColumn="Block">{{'BLOCK'| translate}}
                <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
                <p-sortIcon field="Block"></p-sortIcon>
            </th>
            <th pSortableColumn="Village">{{'VILLAGE'| translate}}
                <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
                <p-sortIcon field="Village"></p-sortIcon>
            </th>
            <th pSortableColumn="Total_Area">{{'TOTAL_AREA'| translate}}
                <p-columnFilter type="text" field="Total_Area" display="menu"></p-columnFilter>
                <p-sortIcon field="Total_Area"></p-sortIcon>
            </th>
        
        </tr>
    </ng-template>
    <p-progressSpinner *ngIf="!drillDownData"></p-progressSpinner>
    <ng-template pTemplate="body" let-drillDownData >
        <tr>
            <td>{{drillDownData.AppId}}</td>
            <td *ngIf="isDate">{{drillDownData.ApprovedDate_filter}}</td>
            <td>{{drillDownData.FarmerName}}</td>
            <td>{{drillDownData.Father_name}}</td>
            <td>{{drillDownData.Mother_Name}}</td>
            <td>{{drillDownData.Mobile}}</td>
            <td>{{drillDownData.District}}</td>
            <td>{{drillDownData.Constituency}}</td>
            <td>{{drillDownData.Block}}</td>
            <td>{{drillDownData.Village}}</td>
            <td>{{drillDownData.Total_Area}}</td>
           
        </tr>
    </ng-template>

    </p-table>
</div>

